export function getYearOptions(count = 11) {
  const currentYear = new Date().getFullYear();
  return Array.from({ length: count }, (_, i) => String(currentYear - i));
}

export function getMonthOptions() {
  return [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December",
  ];
}

export function getDateRange(year, month) {
  const monthIndex = getMonthOptions().indexOf(month);
  if (monthIndex === -1) return { startDate: "", endDate: "" };
  const start = new Date(Number(year), monthIndex, 1);
  const end = new Date(Number(year), monthIndex + 1, 0);
  return {
    startDate: formatDateForAPI(start),
    endDate: formatDateForAPI(end),
  };
}

export function formatDateForAPI(date) {
  if (!date) return "";
  const d = new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function getCurrentMonth() {
  return getMonthOptions()[new Date().getMonth()];
}

export function getCurrentYear() {
  return String(new Date().getFullYear());
}
